import { Component, forwardRef, Input, OnChanges } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'bl-editor-texto-formatacao',
  templateUrl: './editor-texto-formatacao.component.html',
  styleUrls: ['./editor-texto-formatacao.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EditorTextoFormatacaoComponent),
      multi: true,
    },
  ],
  standalone: false,
})
export class EditorTextoFormatacaoComponent implements ControlValueAccessor, OnChanges {
  @Input() altura = '18vh';
  @Input() readonly = false;
  @Input() placeholder = '';

  valor: string = null;
  desabilitado = false;
  somenteLeitura = false;

  private propagarMudanca: (valor: string) => void = () => undefined;
  private propagarToque: () => void = () => undefined;

  ngOnChanges(): void {
    this.atualizarSomenteLeitura();
  }

  writeValue(valor: string): void {
    this.valor = valor ?? null;
  }

  registerOnChange(fn: (valor: string) => void): void {
    this.propagarMudanca = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.propagarToque = fn;
  }

  setDisabledState(desabilitado: boolean): void {
    this.desabilitado = desabilitado;
    this.atualizarSomenteLeitura();
  }

  private atualizarSomenteLeitura(): void {
    this.somenteLeitura = this.readonly || this.desabilitado;
  }

  onValorEditado(html: string): void {
    this.valor = html ?? null;
    this.propagarMudanca(this.valor);
    this.propagarToque();
  }
}
